import "./flipable";
import "./hideable";
import "./Scalable";
